import { Injectable } from "@angular/core";
import { ProductResult } from "src/app/ui/models/domains/pbm/financial-satatement/product-result";
import { SalesOrderItemResult } from "src/app/ui/models/domains/pbm/financial-satatement/sales-order-item-result";
import { SalesOrderResult } from "src/app/ui/models/domains/pbm/financial-satatement/sales-order-result";
import { AbstractParser } from "../../parser";

@Injectable()
export class FindFinancialStatementParser extends AbstractParser<SalesOrderResult[]> {
  parse(payload: any): SalesOrderResult[] {
    const salesOrderResultList: SalesOrderResult[] = [];
    if (payload.FinancialStatementCycleItem) {
      payload.FinancialStatementCycleItem.map((cycleItem) => {
        cycleItem.FinancialStatementGroup.map((financialStatementGroupItem) => {
          if (financialStatementGroupItem.Items.length > 0) {
            financialStatementGroupItem.Items.map((item) => {
              const salesOrderResult = this.parseItems(item, payload.BeneficiarySocialNumber);
              salesOrderResultList.push(salesOrderResult);
            });
          }
        });
      });
    }
    if (payload.Dependents && payload.Dependents.length > 0) {
      payload.Dependents.map((dependent) => {
        dependent.FinancialStatementCycleItem.map((cycleItem) => {
          cycleItem.FinancialStatementGroup.map((financialStatementGroupItem) => {
            if (financialStatementGroupItem.Items.length > 0) {
              financialStatementGroupItem.Items.map((item) => {
                const salesOrderResult = this.parseItems(item, dependent.BeneficiarySocialNumber);
                salesOrderResultList.push(salesOrderResult);
              });
            }
          });
        });
      });
    }
    return salesOrderResultList;
  }

  private parseItems(payload: any, beneficiarySocialNumber: string): SalesOrderResult {
    const salesOrderResult = new SalesOrderResult();
    salesOrderResult.setTransactionDate(payload.SalesOrderResult.TransactionDate);
    salesOrderResult.setUniqueSequentialNumber(payload.SalesOrderResult.UniqueSequentialNumber);
    salesOrderResult.setUniqueSequentialNumberCorrelated(payload.SalesOrderResult.UniqueSequentialNumberCorrelated);
    salesOrderResult.setSalesAction(payload.SalesOrderResult.SalesAction);
    salesOrderResult.setNetworkName(payload.SalesOrderResult.NetworkInfo.Name);
    salesOrderResult.setNetworkFiscalNumber(payload.SalesOrderResult.NetworkInfo.FiscalNumber);
    salesOrderResult.setBeneficiarySocialNumber(beneficiarySocialNumber);
    salesOrderResult.setSalesOrderItemResultList(this.parseSalesOrderItemResultList(payload.SalesOrderResult.Items));
    return salesOrderResult;
  }

  private parseSalesOrderItemResultList(payload: any): SalesOrderItemResult[] {
    const salesOrderItemResultList: SalesOrderItemResult[] = [];
    payload.map((itemResult) => {
      const salesOrderItemResult = new SalesOrderItemResult(this.parseProductResult(itemResult.Product));
      salesOrderItemResult.setProductQuantity(itemResult.ProductQuantity);
      salesOrderItemResult.setPaymentMethod(itemResult.PaymentMethod);
      salesOrderItemResult.setPaymentMethodDescription(itemResult.PaymentMethodDescription);
      salesOrderItemResult.setPrice(itemResult.Price);
      salesOrderItemResult.setUnitPrice(itemResult.UnitPrice);
      salesOrderItemResult.setMdmPrice(itemResult.MdmPrice);
      salesOrderItemResult.setDiscount(itemResult.Discount);
      salesOrderItemResult.setDiscountValue(itemResult.DiscountValue);
      salesOrderItemResult.setNetworkPrice(itemResult.NetworkPrice);
      salesOrderItemResult.setSubsidyDiscount(itemResult.SubsidyDiscount);
      salesOrderItemResult.setSubsidyValue(itemResult.SubsidyValue);
      salesOrderItemResult.setCardValue(itemResult.CardValue);
      salesOrderItemResult.setCheckoutValue(itemResult.CheckoutValue);
      salesOrderItemResult.setEmploymentPayrollValue(itemResult.EmploymentPayrollValue);
      salesOrderItemResultList.push(salesOrderItemResult);
    });
    return salesOrderItemResultList;
  }

  private parseProductResult(payload: any): ProductResult {
    const productResult = new ProductResult();
    productResult.setName(payload.Name);
    productResult.setEan(payload.Ean);
    productResult.setPresentation(payload.Presentation);
    return productResult;
  }
}
